{
  "GENERAL": {
    "CLOSE": "Schließen",
    "SHOWING_RESULTS": "{firstIndex}-{lastIndex} von {totalCount} Elementen werden angezeigt",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Suchen",
      "EMPTY_STATE": "Keine Ergebnisse gefunden"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Mindestens {count} erforderlich"
  }
}
